<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <div class="modal-quit p-20 center">
<h4 class="flex center mb-10">Souhaitez-vous vraiment quitter Swello Pixel ?</h4>
<div class="flex center horizontal">
  <sw-button label="Non" class="mr-3 button-quit-no" @click="$emit('close')"/>
  <sw-button label="Oui" class="button-quit-yes" @click="$emit('closePixel')"/>
  </div>
    </div>
  </sw-modal>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////
//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'CloseModal',
  components: {
    
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
    
    }
  },
  props: {
  },
  computed: {
   
  },
  methods: {
    
    
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/modal/CloseModal.vue